<template>
  <div class="ruibao-img-list-wrap">
    <el-table
      v-if="!loading"
      :height="height"
      :data="data"
      :cell-class-name="getCellClass"
      :row-style="{ height: '61px' }"
    >
      <el-table-column label="设备编号" prop="code" width="120" />
      <el-table-column label="采集用户" prop="nikeName" width="88" />
      <el-table-column label="采集时间" prop="createdAt" width="160">
        <template slot-scope="prop">
          {{ prop.row.createdAt | formatDate }}
        </template>
      </el-table-column>
      <el-table-column label="田块标记" prop="field" width="120">
        <template slot-scope="prop">
          {{ prop.row.field || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="采集对象" prop="category" width="120" />
      <el-table-column label="虫口数" prop="count" width="100">
        <!-- <template slot-scope="prop">
          <el-popover
            v-if="prop.row.count"
            class="left-top"
            trigger="hover"
            placement="right"
            popper-class="pictures-insect__popover"
          >
            <div
              v-for="insect in prop.row.insects"
              :key="insect.id"
              class="pictures-insect"
            >
              <div>
                {{ insect.name }}
              </div>
              <div class="pictures-insect__value">
                {{ insect.count || 0 }}
              </div>
            </div>

            <div slot="reference">
              <span>{{ prop.row.count }}</span>
            </div>
          </el-popover>
        </template> -->
      </el-table-column>
      <el-table-column label="图片" prop="img" width="80">
        <template slot-scope="prop">
          <el-image
            style="cursor:pointer"
            :src="prop.row.predImg"
            @click="showImg(prop.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="采集地点" prop="address" />
      <el-table-column label="操作" width="220">
        <template slot-scope="prop">
          <el-button type="success" @click="showDetail(prop.row)">
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import sleep from '@/utlis/sleep'

export default {
  props: {
    data: Array
  },
  data() {
    return {
      loading: false,
      height: 768
    }
  },
  mounted() {
    this.layout()
  },
  methods: {
    async layout() {
      this.loading = true
      this.height = this.$el.offsetHeight
      await sleep(0.3)
      this.loading = false
    },
    showDetail(row) {
      this.$emit('show-detail', row)
    },
    getCellClass({ column }) {
      return column.property === 'img' ? 'no-padding' : ''
    },
    showImg(row) {
      this.$emit('show-model', row)
    }
  }
}
</script>

<style lang="css" scoped>
.ruibao-img-list-wrap {
  flex: 1;
  overflow: hidden;
}
</style>
